import { render, staticRenderFns } from "./Downloads.vue?vue&type=template&id=69f2ff5b&scoped=true&"
import script from "./Downloads.vue?vue&type=script&lang=ts&"
export * from "./Downloads.vue?vue&type=script&lang=ts&"
import style0 from "./Downloads.vue?vue&type=style&index=0&id=69f2ff5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f2ff5b",
  null
  
)

export default component.exports